import { useState, useEffect } from "react";
import { LayoutDashboard, ChevronRight } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import ButtonNovo from "../ui/Button/ButtonNovo";
import FormularioCliente from "./FormularioCliente";
import TabelaCliente from "./TabelaCliente"; // 👈 Importando a tabela da mesma pasta
import InputPesquisa from "../ui/InputPesquisa"; // 👈 Importando o InputPesquisa

export default function Clientes() {
  const [modoFormulario, setModoFormulario] = useState(false);
  const [clienteEdicao, setClienteEdicao] = useState(null); // Estado para armazenar cliente a ser editado
  const [searchValue, setSearchValue] = useState(""); // Estado para armazenar o valor da pesquisa

  useEffect(() => {
    if (modoFormulario) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [modoFormulario]);

  const handleNovo = () => setModoFormulario(true);  // Ativa o modo de novo cliente
  const handleVoltar = () => setModoFormulario(false); // Volta para a tabela de clientes

  // Função chamada ao clicar em "Editar"
  const handleEditar = (cliente) => {
    console.log("Cliente selecionado para edição:", cliente);
    setClienteEdicao(cliente);
    setModoFormulario(true);
  };

  return (
    <div
      className="h-full w-full relative overflow-hidden flex flex-col pt-6"
      style={{ fontFamily: "Roboto, Helvetica, Arial, sans-serif" }}
    >
      {/* 🔗 Breadcrumb */}
      <nav
        className="flex items-center space-x-3 text-sm px-4 mt-4 mb-6"
        style={{
          fontFamily: "'Source Sans Pro', sans-serif",
          fontSize: "15px",
          color: "#001D34",
        }}
      >
        <LayoutDashboard size={16} className="text-[#001D34]" />
        <span className="cursor-pointer font-medium hover:underline">Lista</span>
        <ChevronRight size={12} className="text-slate-400" />
        <span className="font-medium">Clientes</span>

        {modoFormulario && (
          <>
            <ChevronRight size={12} className="text-slate-400" />
            <span className="font-medium">Cadastro de Cliente</span>
          </>
        )}
      </nav>

      {/* 🔹 Conteúdo da Página */}
      <div className="px-4 flex-1">
        <AnimatePresence mode="wait">
          {!modoFormulario ? (
            // 🔹 LISTA DE CLIENTES (com tabela)
            <motion.div
              key="lista"
              initial={{ x: 0, opacity: 1 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: "-100%", opacity: 0 }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
              className="h-full"
            >
              <div className="bg-white rounded-2xl shadow-sm p-5">
                {/* 🔘 Campo de Pesquisa + Botão Novo */}
                <div className="flex justify-between items-center mb-3">
                  <InputPesquisa
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    placeholder="Pesquisar Cliente..."
                  />
                  <ButtonNovo onClick={handleNovo} />
                </div>

                <div className="w-full h-[1px] bg-[#d8d5d6] mb-3" />

                {/* 👇 Renderiza a tabela de clientes com o filtro ativo */}
                <TabelaCliente onEditar={handleEditar} searchValue={searchValue} />
              </div>
            </motion.div>
          ) : (
            // 🔹 FORMULÁRIO DE CADASTRO (entra pela direita)
            <motion.div
              key="formulario"
              initial={{ x: "100%", opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: "100%", opacity: 0 }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
              className="flex-1 h-full"
            >
              <FormularioCliente
                clienteEdicao={clienteEdicao}
                onVoltar={handleVoltar}
              />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
}
